module.exports = __webpack_public_path__ + "media/open.34ab7299.mp3";